import { CheckAccess } from "./CheckAccess";

export * from "./CheckAccess";

export default CheckAccess;